import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'gateway.views.dashboard.title',
        defaultMessage: 'Dashboard'
    },
    openQuotesTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Quotes',
        defaultMessage: 'Open Quotes'
    },
    policyChangeTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Policy Changes',
        defaultMessage: 'Open Policy Changes'
    },
    cancellationsTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Cancellations',
        defaultMessage: 'Open Cancellations'
    },
    openRenewalsTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Renewals',
        defaultMessage: 'Open Renewals'
    },
    upComingActivities: {
        id: 'gateway.views.activities.Activities for the next 7 days',
        defaultMessage: 'Your Open Activities for the next 7 days'
    },
    pendingQuotesTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Pending Quotes',
        defaultMessage: 'Pending Quotes'
    },
    pendingChangeTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Pending Policy Changes',
        defaultMessage: 'Pending Policy Changes'
    },
    pendingCancellationsTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Pending Cancellations',
        defaultMessage: 'Pending Cancellations'
    },
    pendingRenewalsTile: {
        id: 'gateway.directives.GatewayDashboardDirective.gateway-dashboard.Pending Renewals',
        defaultMessage: 'Pending Renewals'
    }
});
